import React, { memo, useState } from "react";
import {
	Modal, ModalBody, ModalFooter,
	Button
} from "reactstrap";

const NextModal = memo( function NextModal({
	isOpen, handler, submitResponse
}) {
	const [submitClick,setSubmitClick] = useState(true);
	const toggle = () => {
		handler(prev => false);
	};

	const submitAndShowNext = () => {
		if(submitClick){
			toggle();
			submitResponse();
			setSubmitClick(false);
			setTimeout(()=>{
				setSubmitClick(true);	
			},1000)
		}
	};

	return (
		<Modal isOpen={isOpen} size="sm">
			<ModalBody>
				<div>Do you want to go to next Question?</div>
			</ModalBody>

			<ModalFooter>
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={submitAndShowNext}
				>Yes</Button>
				
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={toggle}
				>No</Button>
			</ModalFooter>
		</Modal>
	);
});

export default NextModal;